import { path } from 'ramda'
import React from 'react'
import styled, { withTheme, css } from 'styled-components'

import { ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'

const Wrapper = styled.div`
  padding: 16px 24px;
`

const AirportAndDate = styled.span`
  ${({ theme }) => theme.fontSize('14px')};
  line-height: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primaryText};
  margin-bottom: 12px;
  display: block;
`

const ArrivalInformation = styled.div`
  display: flex;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-bottom: 12px;
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 50%;
`

const InfoTitle = styled.span`
  text-transform: uppercase;
  ${({ theme }) => theme.fontSize('12px')};
`

const InfoText = styled.span`
  ${({ theme }) => theme.fontSize('32px')};
  line-height: 32px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primaryText};
  margin-bottom: 2px;
`

const InfoAdditional = styled.span`
  ${({ theme }) => theme.fontSize('14px')};
  ${({ obsolete }) => !!obsolete && css`
    opacity: 0.9;
    text-decoration-line: line-through;
  `}
`

const BaggageClaimWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }) => theme.fontSize('12px')};
  line-height: 18px;
  color: ${({ theme }) => theme.colors.primaryText};
  margin-left: -4px;

  ${ColoredIcon} {
    margin-right: 4px;
  }
`

const FlightInformation = withTheme(({
  theme,
  className,
  flightInfo
}) => {
  const {
    time,
    baggageClaim,
    oldTime,
    gate,
    gateLabel,
    connectionAirport,
    date,
    flightTypeLabel
  } = flightInfo
  return <Wrapper className={className}>
    <AirportAndDate>{`${connectionAirport} • ${date}`}</AirportAndDate>
    <ArrivalInformation>
      <InfoWrapper>
        <InfoTitle>{gateLabel}</InfoTitle>
        <InfoText>{gate.name}</InfoText>
        <InfoAdditional>{path(['position', 'structureName'], gate)}</InfoAdditional>
      </InfoWrapper>
      <InfoWrapper>
        <InfoTitle>{flightTypeLabel}</InfoTitle>
        <InfoText>{time}</InfoText>
        {!!oldTime && <InfoAdditional obsolete>{oldTime}</InfoAdditional>}
      </InfoWrapper>
    </ArrivalInformation>

    {!!baggageClaim && <BaggageClaimWrapper>
      <ColoredIcon id={'bag-claim'} width={24} height={24} fillColor={theme.colors.primaryText} />
      <span>{baggageClaim}</span>
    </BaggageClaimWrapper>}

  </Wrapper>
})

export default FlightInformation
